/* The collapsed View price chip stays 16px above the viewport safe area.
   Expanded purchase-bar footer clearance is owned by its existing controller. */
(() => {
  if (window.mkFooterLayoutReady) return;
  window.mkFooterLayoutReady = true;
  const clearLegacyOffset = () => document.querySelectorAll('[data-sticky-reopen]').forEach(control => {
    control.style.removeProperty('--mk-footer-reopen-bottom');
  });
  clearLegacyOffset();
  document.addEventListener('DOMContentLoaded', clearLegacyOffset, {once:true});
  document.addEventListener('shopify:section:load', clearLegacyOffset);
})();
